import React, { useContext } from 'react';
import { WidthContext } from '../../WidthContext';
import './inlinePhotos.scss';
import { lang } from '../lang';

function InlinePhotos({ index }) {
  const { srcD, srcM, caption } = lang.inline[index];
  const { viewSize } = useContext(WidthContext);
  return (
    <figure className="inline">
      <img className="inline__img" alt="" src={viewSize === 'large' ? srcD : srcM}></img>
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}

export default InlinePhotos;
